import { FormEvent, useState } from 'react';
import { useAuth } from '../AuthContext';
import { post, setToken } from '../lib/api';
import { ErrorNote } from '../components/ui';
import type { Profile } from '../lib/types';

/** First run: create the first parent account. */
export default function Setup(): JSX.Element {
  const { refresh } = useAuth();
  const [name, setName] = useState('');
  const [pin, setPin] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    if (!/^\d{4,8}$/.test(pin)) {
      setError('Pick a PIN of 4-8 digits.');
      return;
    }
    if (pin !== confirm) {
      setError('The two PINs do not match.');
      return;
    }
    setBusy(true);
    try {
      const res = await post<{ user: Profile; token: string }>('/api/auth/setup', { name: name.trim(), pin });
      setToken(res.token);
      await refresh();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app no-nav">
      <h1>Welcome 👋</h1>
      <p className="muted">
        Let's create the first parent account. You can add your partner and the kids straight after.
      </p>
      <form className="card" onSubmit={submit}>
        <ErrorNote error={error} />
        <label className="field">
          <span>Your name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Mum" required maxLength={40} />
        </label>
        <label className="field">
          <span>PIN (4-8 digits)</span>
          <input
            className="pin-input"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 8))}
            inputMode="numeric"
            autoComplete="new-password"
            required
          />
        </label>
        <label className="field">
          <span>Repeat PIN</span>
          <input
            className="pin-input"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value.replace(/\D/g, '').slice(0, 8))}
            inputMode="numeric"
            autoComplete="new-password"
            required
          />
        </label>
        <button className="btn block" type="submit" disabled={busy || !name.trim()}>
          {busy ? 'Creating…' : 'Create account'}
        </button>
      </form>
    </div>
  );
}
